import { createContext, useContext } from 'react';

export interface PhoneUndoContextValue {
  canUndo: boolean;
  canRedo: boolean;
  undoLabel: string | null;
  redoLabel: string | null;
  onUndo: () => void;
  onRedo: () => void;
}

const defaultValue: PhoneUndoContextValue = {
  canUndo: false,
  canRedo: false,
  undoLabel: null,
  redoLabel: null,
  onUndo: () => {},
  onRedo: () => {},
};

const PhoneUndoContext = createContext<PhoneUndoContextValue>(defaultValue);

export const PhoneUndoProvider = PhoneUndoContext.Provider;

export function usePhoneUndo(): PhoneUndoContextValue {
  return useContext(PhoneUndoContext);
}
